/* Refs */
export const refs = {
  feedbacksContainer: document.querySelector('.feedbacks-container'),
  artistsList: document.querySelector('#artists-list'),
  artistDetailsModal: document.querySelector('.artist-details-modal'),
  artistDetailsModalCloseBtn: document.querySelector(
    '.artist-details-modal-close-btn'
  ),
  menuGenres: document.querySelector('.dropdown-menu-genres'),
  menuSort: document.querySelector('.dropdown-menu-sort'),
  panelSearch: document.querySelector('.filters-content'),
  btnGenres: document.querySelector('.dropdown-toggle-genres'),
  btnSort: document.querySelector('.dropdown-toggle-sort'),
  
  btnSearch: document.querySelector('.search-and-filters-toggle'),
  searchInput: document.querySelector('.search-input'),
  searchBtnRequest: document.querySelector('.search-btn'),
  iconSearch: document.querySelector('.dropdown-icon-search'),
  iconSort: document.querySelector('.sort-icon'),
  iconGenres: document.querySelector('.genres-icon'),
  loaderArtistsWrapper: document.querySelector('.artists-loader-container'),
  toggleBtn: document.querySelector('.header-toggle'),
  mobileMenu: document.querySelector('.header-mobile-menu'),
  menuLinks: document.querySelectorAll('.header-mob-nav-link'),
  navLinks: document.querySelectorAll('.header-nav-link'),
  sections: document.querySelectorAll('section, .footer'),
  artistDetailsModalBackdrope: document.querySelector(
    '.artist-details-backdrop'
  ),
  heroBtn: document.querySelector('.hero-btn'),
  resetBtn: document.querySelector('.filters-reset-btn'),
  feedbackLoader: document.querySelector('.feedback-loader'),
  feedbackLoaderContainer: document.querySelector('.feedback-loader-container'),
};
